class ReportMapController {
    constructor($timeout) {
        "ngInject";

        let vm = this;
        vm.map = null;
        vm.$onInit = init;

        function init() {
            if (vm.resolve && vm.resolve.report) {
                vm.report = vm.resolve.report;

                if (!!vm.report.latitude && !!vm.report.longitude) {
                    console.log("Report ", vm.report)
                    $timeout(() => {
                        initMap();
                        addMarker();
                    }, 0);
                }
            }
        }

        function initMap() {
            vm.map = L.map('reportMap').setView([vm.report.latitude, vm.report.longitude], 16)
            L.tileLayer(
                'https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}',
                {
                    attribution: '<a href="http://openstreetmap.org">OpenStreetMap</a> | <a href="http://mapbox.com">Mapbox</a>',
                    maxZoom: 21,
                    id: 'mapbox.streets',
                    accessToken: 'pk.eyJ1IjoibWFpbHZpcm9vcyIsImEiOiJjajlkNnJ6bnQxeDFwMnFveW9hcHJ6NGI4In0.81GT3m2HWbB2efieELsj8Q',
                    zoomAnimation: true,
                }).addTo(vm.map)
        }

        function addMarker() {
            L.marker([vm.report.latitude, vm.report.longitude], {
                icon: L.icon({
                    iconUrl: 'assets/img/pin.png',
                    iconSize: [29.5, 40],
                    iconAnchor: [15, 40],
                }),
            }).addTo(vm.map)
        }
    }
}

export default ReportMapController;



// WEBPACK FOOTER //
// ./client/app/common/reportMap/reportMap.controller.js